import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPointOfSale } from '../../shared/models/core/point-of-sale';
import { ISalesOffice } from '../../shared/models/core/sales-office';
import { RootState } from '../store';

interface IAuthState {
  selectedPos: IPointOfSale | null;
  oldSelectedPos: IPointOfSale | null;
  selectedSalesOffice: ISalesOffice | null;
  isAuthenticated: boolean;
  isTokenExpired?: boolean;
}

const initialState: IAuthState = {
  selectedPos: null,
  oldSelectedPos: null,
  selectedSalesOffice: null,
  isAuthenticated: false,
  isTokenExpired: undefined,
};

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setSelectedPost: (state, action: PayloadAction<{ value: IPointOfSale | null }>) => {
      state.selectedPos = action.payload.value;
    },
    setOldSelectedPost: (state, action: PayloadAction<{ value: IPointOfSale }>) => {
      state.oldSelectedPos = action.payload.value;
    },
    setSelectedSalesOffice: (state, action: PayloadAction<{ value: ISalesOffice | null }>) => {
      state.selectedSalesOffice = action.payload.value;
    },
    setInitialState: (state) => {
      state.selectedPos = initialState.selectedPos;
      state.oldSelectedPos = initialState.oldSelectedPos;
      state.selectedSalesOffice = initialState.selectedSalesOffice;
      state.isAuthenticated = initialState.isAuthenticated;
      state.isTokenExpired = initialState.isTokenExpired;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.isTokenExpired = false;
      state.selectedSalesOffice = null;
    },
    setIsTokenExpired: (
      state,
      action: PayloadAction<{
        expired: boolean;
      }>
    ) => {
      state.isTokenExpired = action.payload.expired;
    },
  },
});

export const {
  setSelectedPost,
  setOldSelectedPost,
  setSelectedSalesOffice,
  setInitialState,
  logout,
  setIsTokenExpired,
} = authSlice.actions;

const AuthReducer = authSlice.reducer;

export const selectSelectedPos = (state: RootState) => state.auth.selectedPos;
export const selectSelectedSalesOffice = (state: RootState) => state.auth.selectedSalesOffice;

export default AuthReducer;
